import React, { useContext, useCallback } from 'react';
import { useLabels, useRequestData } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { isBrowser } from 'ws-scripts/modules/environment';
import { UIContext, FiltersContext } from '../contexts';
import { URL_FACET_KEYS } from '../hooks/useDeepLinking';
import { backToIncentivesEvent } from '../utils/wueTracking';

const toSlug = (v) =>
	String(v)
		.toLowerCase()
		.replace(/\s+/g, '-')
		.replace(/[^a-z0-9-]/g, '');

const BackToIncentivesLink = () => {
	const labels = useLabels();
	const { changeView } = useContext(UIContext);
	const { activeFilters } = useContext(FiltersContext);
	const { widgetName, windowId } = useRequestData();

	const label = labels.get('INCENTIVES_BACK_TO_INCENTIVES');

	const handleClick = useCallback(() => {
		trackEvent(
			widgetName,
			windowId,
			backToIncentivesEvent({ label, activeFilters })
		);
		changeView('default');
		if (isBrowser) {
			const url = new URL(window.location);
			url.searchParams.delete('gvId');
			// Only URL-scoped facets (offerTypes) are carried back to listing.
			// Year / bodyStyle / make / model stay in-session per Rally F243497.
			URL_FACET_KEYS.forEach((key) => {
				url.searchParams.delete(key);
				const values = activeFilters[key] || [];
				if (values.length > 0) {
					url.searchParams.set(key, values.map(toSlug).join(','));
				}
			});
			window.history.replaceState(null, '', url);
		}
	}, [changeView, activeFilters, widgetName, windowId, label]);

	return (
		<button
			type="button"
			className="back-to-incentives-link btn btn-link d-inline-flex align-items-center mb-3 p-0"
			aria-label="Back to vehicle results"
			onClick={handleClick}
		>
			<span
				className="glyphicon-chevron-left ddc-icon ddc-icon-arrow-left mr-1"
				aria-hidden="true"
			/>
			{label}
		</button>
	);
};

export default BackToIncentivesLink;
